<template>
    <div>

        <template v-if="isTab">
            <b-tabs content-class="mt-3">
                <b-tab active>
                    <template #title>
                        <span class="mr-2">Prises</span>
                        <span>
                            <b-badge variant="danger">{{filterPriceInit.length}}</b-badge>
                        </span>
                    </template>
                    <b-row>
                        <b-col
                                v-for="(item,index) in filterPriceInit"
                                :key="index"
                                cols="12" md="4">
                            <Price :price="item" :prices="filterPriceInit" :isServer="isServer"></Price>
                        </b-col>
                    </b-row>
                </b-tab>
                <!--END Main-->
                <b-tab>
                    <template #title>
                        <span class="mr-2">Discount Prises</span>
                        <span>
                            <b-badge variant="danger">{{filterPriceOffer.length}}</b-badge>
                        </span>
                    </template>
                    <b-row>
                        <b-col
                                v-for="(item,index) in filterPriceOffer"
                                :key="index"
                                cols="12" md="4">
                            <Price :price="item" :prices="filterPriceOffer" :isServer="isServer"></Price>
                        </b-col>
                    </b-row>
                </b-tab>
                <!--END Offer-->
            </b-tabs>
        </template>
        <template v-else>
           <b-row>
               <b-col
                       v-for="(item,index) in prices"
                       :key="index"
                       cols="12" md="4">
                   <Price :price="item" :prices="prices" :isServer="isServer"></Price>
               </b-col>
           </b-row>
        </template>
        <!--END Front Prices-->


    </div>
</template>

<script>
    import Price from './Price';

    export default {
        name: "Prices",
        components: {
            Price
        },
        props: {
            prices: {
                type: Array,
                default: null
            },
            isServer: {
                type: Boolean,
                default: false
            },
            isTab: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {}
        },
        computed: {
            filterPriceInit() {
                return this.prices.filter(item => {
                    return item.priceGroup.match('init');
                })
            },
            filterPriceOffer() {
                return this.prices.filter(item => {
                    return item.priceGroup.match('offer');
                })
            },

        },
    }
</script>

<style scoped>

</style>